var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-canvas-edit-image-button",on:{"click":_vm.editImage}},[_vm._v("Edit Image")])
}
var staticRenderFns = []

export { render, staticRenderFns }